import * as yup from "yup";

export const profilePageSchema = yup.object().shape({
  title: yup.string().nullable().oneOf([null, "", "Mr", "Mrs", "Ms", "Dr"]),
  email: yup
    .string()
    .email("Please enter a valid email address")
    .max(100, "The email may not be greater than 100 characters")
    .required("Please enter a valid email address"),
  first_name: yup
    .string()
    .max(50, "The first name may not be greater than 50 characters")
    .required("Please enter the first name"),
  last_name: yup
    .string()
    .max(50, "The last name may not be greater than 50 characters")
    .required("Please enter the last name"),
  contact_number: yup
    .string()
    .max(15, "Invalid Number")
    .required("Please enter the contact number"),
  country_code: yup.string().required("Coutnry Code is required"),
  address: yup
    .string()
    .max(100, "The address may not be greater than 100 characters")
    .required("Please enter the address"),
  country: yup.string().required("Please select the country"),
  city: yup
    .string()
    .max(50, "The city may not be greater than 50 characters")
    .required("Please enter the city"),
  state: yup.string().required("Please select the state"),
  zipcode: yup
    .string()
    .min(4, "Zip/postal code may not be less than 4 characters")
    .max(10, "The zip/postal code may not be greater than 10 characters")
    .required("Please enter the zip/postal code"),
  company: yup
    .string("Please enter the company name")
    .max(100, "The company name not be greater than 100 characters")
    .nullable(),
  newsletter: yup.boolean().nullable().notRequired(),
  date_of_birth: yup.object().shape({
    day: yup.string().required(),
    month: yup.string().required(),
    year: yup.string().required(),
  }),
  photo: yup.string().nullable().notRequired(),
});

export const documentUploadSchema = yup.object().shape({
  insuranceCarrierOther: yup.string().trim().when(["documentType", "insuranceCarrier"], {
    is: (documentType, carrier) => documentType === "IP" && carrier === "Other",
    then: yup.string().trim().max(100, "Carrier name must be 100 characters or fewer").nullable(),
    otherwise: yup.string().nullable(),
  }),
  insuranceCarrier: yup.string().when("documentType", {
    is: "IP",
    then: yup.string().nullable(),
    otherwise: yup.string().nullable(),
  }),
  docNumber: yup.string().required("Document Number required"),
  exp_date: yup.object().shape({
    day: yup.string().required("r"),
    month: yup.string().required("r"),
    year: yup.string().required("r"),
  }),
});

/*******************
@purpose : Payment Gateway Validation Schema
@Author : INIC
 ******************/
export const paymentGatewaySchema = yup.object().shape({
  nameOnCard: yup
    .string()
    .max(100, "The name on card may not be greater than 100 characters")
    .required("Please enter the name on card"),
  billingAddress: yup
    .string()
    .max(100, "The billing address may not be greater than 100 characters")
    .required("Please enter the billing address"),
  country: yup.string().required("Please select the country"),
  // state: yup.string().required("Please select the state"),
  // city: yup
  //   .string()
  //   .max(50, "The city may not be greater than 50 characters")
  //   .required("Please enter the city"),
  zipcode: yup
    .string()
    .min(4, "Zip/postal code may not be less than 4 characters")
    .max(10, "Zip/postal code may not be greater than 10 characters")
    .required("Please enter the zip/postal code"),
});

/*******************
@purpose : vehicle Booking Validation Schema
@Author : INIC
 ******************/
export const vehicleBookingSchema = yup.object().shape({
  email: yup
    .string()
    .nullable()
    .trim()
    .email("Please enter a valid email address")
    .max(100, "The email may not be greater than 100 characters")
    .required("Please enter a valid email address"),
  first_name: yup
    .string()
    .nullable()
    .trim()
    .max(50, "The first name may not be greater than 50 characters")
    .required("Please enter the first name"),
  last_name: yup
    .string()
    .nullable()
    .trim()
    .max(50, "The last name may not be greater than 50 characters")
    .required("Please enter the last name"),

  age: yup.string().required("Age is required"),
  delivery_type: yup.boolean(),
  pickup_option: yup.boolean(),
  address: yup.string().when("pickup_option", {
    is: true,
    then: yup
      .string()
      .max(100, "The address may not be greater than 50 characters")
      .required("Please enter your address"),
  }),
  start_address: yup.string().when("pickup_option", {
    is: true,
    then: yup
      .string()
      .max(100, "The address may not be greater than 50 characters")
      .required("Please enter your address"),
  }),
  dropoff_address: yup.string().when("one_way_option", {
    is: true,
    then: yup
      .string()
      .max(100, "The address may not be greater than 50 characters")
      .required("Please enter your return address"),
  }),
  return_address: yup.string().when("one_way_option", {
    is: true,
    then: yup
      .string()
      .max(100, "The address may not be greater than 50 characters")
      .required("Please enter your return address"),
  }),
  city: yup.string().when("pickup_option", {
    is: true,
    then: yup
      .string()
      .max(50, "The city may not be greater than 50 characters")
      .required("Please enter the city"),
  }),
});

export const reservationSchema = yup.object().shape({
  cardName: yup
    .string()
    .max(100, "The name on card may not be greater than 100 characters")
    .required("Please enter the name on card"),
  billingAddress: yup
    .string()
    .max(100, "The billing address may not be greater than 100 characters")
    .required("Please enter the billing address"),
  country: yup.string().required("Please select the country"),
  // state: yup.string().required("Please select the state"),
  // city: yup
  //   .string()
  //   .max(50, "The city may not be greater than 50 characters")
  //   .required("Please enter the city"),
  zipcode: yup
    .string()
    .min(4, "Zip/postal code may not be less than 4 characters")
    .max(10, "The zip/postal code may not be greater than 10 characters")
    .required("Please enter the zip/postal code"),
  cardSave: yup.boolean().nullable().notRequired(),
});

/*******************
@purpose : Payment Gateway Validation Schema
@Author : INIC
 ******************/
export const contactUsFormSchema = yup.object().shape({
  firstName: yup
    .string()
    .max(50, "The first name not be greater than 50 characters")
    .required("Please enter the first name"),
  email: yup
    .string()
    .email("Please enter a valid email address")
    .max(100, "The email may not be greater than 100 characters")
    .required("Please enter a valid email address"),
  subject: yup
    .string()
    .max(100, "The subject may not be greater than 100 characters")
    .required("Please enter the subject"),
  message: yup
    .string()
    .max(2000, "The message may not be greater than 2000 characters")
    .required("Please enter the message"),
  contactNumber: yup
    .string()
    .max(15, "Invalid Number")
    .required("Please enter the phone number"),
});

/*******************
@purpose : Klaviyo Form Schema
@Author : INIC
 ******************/
export const klaviyoFormSchema = yup.object().shape({
  email: yup
    .string()
    .email("Please enter a valid email address")
    .max(100, "The email may not be greater than 100 characters")
    .required("Please enter your email address"),
});
